/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Users_Filtered_By_EmailInputs */

const cs_users_filtered_by_email = /** @type {(inputs: Users_Filtered_By_EmailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filtr: ${i?.email}`)
};

const en_users_filtered_by_email = /** @type {(inputs: Users_Filtered_By_EmailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filter: ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Filter: {email}" |
*
* @param {Users_Filtered_By_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_filtered_by_email = /** @type {((inputs: Users_Filtered_By_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Filtered_By_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_filtered_by_email(inputs)
	return cs_users_filtered_by_email(inputs)
});